import { Section } from '@/components/ui/layouts/sections/Section';

import { bordersList } from '@mage-ui/styled-system/recipes';
import { Instances } from '../Instances';

export const ResourcesBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        epi: data?.fields?.epi,
        meta: data?.fields?.meta_info,
        intro: data?.fields?.intro,
      }}
    >
      <ul className={bordersList().root}>
        <Instances instances={data?.relations?.ResourcesList} />
      </ul>
    </Section>
  );
};
